export const InsertToLocalStorage = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const RetrieveFromLocalStorage = (key: string): string => {
  const data = localStorage.getItem(key);
  const cleanData = data ? JSON.parse(data) : null;
  return cleanData;
};

export const DeleteFromLocalStorage = (key: string): void => {
  localStorage.removeItem(key);
};
